import { render, staticRenderFns } from "./ApplicationFormPreferredDeposit.vue?vue&type=template&id=3738a60a&scoped=true"
import script from "./ApplicationFormPreferredDeposit.vue?vue&type=script&lang=ts"
export * from "./ApplicationFormPreferredDeposit.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationFormPreferredDeposit.vue?vue&type=style&index=0&id=3738a60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738a60a",
  null
  
)

export default component.exports